export default __webpack_public_path__ + "static/media/signInBkg.1d4719e6.webp";